export interface SystemInfo {
  AppsCblMode: boolean;
  AssemblyConfiguration: string;
  AssemblyVersion: string;
  CloudBerryMode: boolean;
  Configuration: string;
  GAA: boolean;
  FaviconUrl: string;
  IsImmutability: boolean;
  LogoUrl: string;
  ProductMode: ProductMode;
  SiteInBackup: boolean | null; // we get `null` when backup for SP is disabled
  StorageRegion: string;
  StorageState: StorageState;
}

export enum StorageState {
  Ok = 'OK',
  ConnectionError = 'ConnectionError',
  NotSet = 'NotSet',
  Unknown = 'Unknown'
}

export enum ProductMode {
  Mbs = 'Mbs',
  Resale = 'Resale'
}
